import React from 'react'
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from 'recharts'
import { Card } from 'antd'

interface ActivityData {
  name: string
  value: number
}

interface ActivityDistributionChartProps {
  data: ActivityData[]
  height?: number
  title?: string
  colors?: string[]
}

const DEFAULT_COLORS = [
  '#1890ff',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#722ed1',
  '#eb2f96',
  '#13c2c2',
  '#52c41a',
]

export const ActivityDistributionChart: React.FC<ActivityDistributionChartProps> = ({
  data,
  height = 300,
  title = 'Activity Type Distribution',
  colors = DEFAULT_COLORS,
}) => {
  return (
    <Card title={title} bordered style={{ marginBottom: '24px' }}>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `${typeof value === 'number' ? value.toFixed(0) : value} hours`} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  )
}
